import { IFormThingsToImprove } from 'legacy/lut/classes/models/partner360/IFormThingsToImprove'

interface IPrepareKeyInitiativeSaveOptions {
  saveAsNew: boolean
  previousEntryId?: number
  persistedEntryId?: number
}

export const prepareKeyInitiativeSave = (
  mappedData: Partial<IFormThingsToImprove>,
  { saveAsNew, previousEntryId, persistedEntryId }: IPrepareKeyInitiativeSaveOptions
): { data: Partial<IFormThingsToImprove>; action: 'Create' | 'Update' } => {
  if (saveAsNew) {
    const data = { ...mappedData }
    delete data.EntryId

    return {
      data: { ...data, PreviousEntryId: previousEntryId ?? null },
      action: 'Create',
    }
  }

  const data = { ...mappedData }
  if (!data.EntryId && persistedEntryId) {
    data.EntryId = persistedEntryId
  }
  return { data, action: data.EntryId ? 'Update' : 'Create' }
}
